export const categories = [
  {
    id: "cat1",
    image: `${process.env.PUBLIC_URL}/Starches.jpg`,
    products: [
      { id: 2 }, { id: 3 }, { id: 1 }, { id: 8 }, { id: 4 }, { id: 9 }, { id: 7 }, { id: 5 },
      { id: 6 },
    ],
  },
  {
    id: "cat2",
    image: `${process.env.PUBLIC_URL}/Sweeteners.avif`,
    products: [
      { id: 52 }, { id: 51 }, { id: 67 }, { id: 63 }, { id: 61 }, { id: 70 }, { id: 56 }, { id: 57 },
      { id: 66 }, { id: 58 }, { id: 62 }, { id: 68 }, { id: 54 }, { id: 53 }, { id: 59 }, { id: 60 },
      { id: 64 }, { id: 55 }, { id: 65 }, { id: 69 },
    ],
  },
  {
    id: "cat3",
    image: `${process.env.PUBLIC_URL}/Thickener.jpg`,
    products: [
      { id: 102 }, { id: 106 }, { id: 107 }, { id: 112 }, { id: 103 }, { id: 110 }, { id: 104 }, { id: 113 },
      { id: 109 }, { id: 105 }, { id: 111 }, { id: 108 }, { id: 101 },
    ],
  },
  {
    id: "cat4",
    image: `${process.env.PUBLIC_URL}/Colorant.jpg`,
    products: [
      { id: 157 }, { id: 161 }, { id: 159 }, { id: 162 }, { id: 163 }, { id: 156 }, { id: 158 }, { id: 154 },
      { id: 160 }, { id: 155 }, { id: 152 }, { id: 153 }, { id: 151 }, { id: 164 },
    ],
  },
  {
    id: "cat5",
    image: `${process.env.PUBLIC_URL}/Natural_Colorant.jpg`,
    products: [
      { id: 208 }, { id: 204 }, { id: 201 }, { id: 212 }, { id: 206 }, { id: 213 }, { id: 205 }, { id: 203 },
      { id: 209 }, { id: 210 }, { id: 207 }, { id: 211 }, { id: 202 },
    ],
  },
  {
    id: "cat6",
    image: `${process.env.PUBLIC_URL}/Preservatives.jpg`,
    products: [
      { id: 258 }, { id: 257 }, { id: 256 }, { id: 260 }, { id: 252 }, { id: 262 }, { id: 254 }, { id: 253 },
      { id: 263 }, { id: 261 }, { id: 265 }, { id: 266 }, { id: 264 }, { id: 251 }, { id: 259 }, { id: 255 },
    ],
  },
  {
    id: "cat7",
    image: `${process.env.PUBLIC_URL}/Acidifiers.jpg`,
    products: [
      { id: 301 }, { id: 303 }, { id: 302 }, { id: 304 }, { id: 306 }, { id: 305 }, { id: 314 }, { id: 313 },
      { id: 307 }, { id: 308 }, { id: 309 }, { id: 311 }, { id: 310 }, { id: 315 }, { id: 312 },
    ],
  },
  {
    id: "cat8",
    image: `${process.env.PUBLIC_URL}/Emulsifiers.png`,
    products: [
      { id: 364 }, { id: 356 }, { id: 357 }, { id: 358 }, { id: 369 }, { id: 361 }, { id: 353 }, { id: 354 },
      { id: 363 }, { id: 362 }, { id: 360 }, { id: 351 }, { id: 368 }, { id: 352 }, { id: 367 }, { id: 359 },
      { id: 355 }, { id: 366 }, { id: 365 },
    ],
  },
  {
    id: "cat9",
    image: `${process.env.PUBLIC_URL}/Cocoa.avif`,
    products: [
      { id: 402 }, { id: 404 }, { id: 403 }, { id: 401 },
    ],
  },
  {
    id: "cat10",
    image: `${process.env.PUBLIC_URL}/Extract.webp`,
    products: [
      { id: 459 }, { id: 460 }, { id: 456 }, { id: 457 }, { id: 458 }, { id: 453 }, { id: 452 }, { id: 454 },
      { id: 451 }, { id: 455 },
    ],
  },
  {
    id: "cat11",
    image: `${process.env.PUBLIC_URL}/Dairy.png`,
    products: [
      { id: 504 }, { id: 507 }, { id: 505 }, { id: 508 }, { id: 503 }, { id: 506 }, { id: 502 }, { id: 501 },
    ],
  },
  {
    id: "cat13",
    image: `${process.env.PUBLIC_URL}/Oils.jpg`,
    products: [
      { id: 601 }, { id: 602 }, { id: 603 }, { id: 604 }, { id: 605 }, { id: 606 }, { id: 607 },
    ],
  },
  {
    id: "cat14",
    image: `${process.env.PUBLIC_URL}/Bread.jpg`,
    products: [
      { id: 651 }, { id: 652 }, { id: 653 }, { id: 654 }, { id: 655 },
    ],
  },
  {
    id: "cat15",
    image: `${process.env.PUBLIC_URL}/Fibers.jpg`,
    products: [
      { id: 701 }, { id: 702 }, { id: 703 }, { id: 704 }, { id: 705 },
    ],
  },
  {
    id: "cat16",
    image: `${process.env.PUBLIC_URL}/Minerals.jpg`,
    products: [
      { id: 751 }, { id: 752 }, { id: 753 }, { id: 754 }, { id: 755 }, { id: 756 }, { id: 757 }, { id: 758 },
      { id: 759 }, { id: 760 }, { id: 761 }, { id: 762 }, { id: 763 }, { id: 764 }, { id: 765 }, { id: 766 },
      { id: 767 }, { id: 768 }, { id: 769 }, { id: 770 }, { id: 771 }, { id: 772 }, { id: 773 }, { id: 774 },
      { id: 775 }, { id: 776 }, { id: 777 }, { id: 778 }, { id: 779 }, { id: 780 }, { id: 781 }, { id: 782 },
      { id: 783 },
    ],
  },
  {
    id: "cat12",
    image: `${process.env.PUBLIC_URL}/Other.jpg`,
    products: [
      { id: 537 }, { id: 538 }, { id: 539 }, { id: 524 }, { id: 536 }, { id: 535 }, { id: 529 }, { id: 540 },
      { id: 541 }, { id: 521 }, { id: 527 }, { id: 526 }, { id: 542 }, { id: 530 }, { id: 534 }, { id: 543 },
      { id: 544 }, { id: 525 }, { id: 545 }, { id: 546 }, { id: 547 }, { id: 531 }, { id: 532 }, { id: 533 },
      { id: 548 }, { id: 549 }, { id: 550 }, { id: 551 }, { id: 552 }, { id: 553 }, { id: 528 }, { id: 522 },
      { id: 523 },
    ],
  },
];
